import { useEffect, useMemo, useState } from "react";
import { fhirClient } from "src/App";
import useAuth from "src/careflow/ph-core/authentication/hook/useAuth";
import { PractitionerRole } from "src/careflow/ph-core/fhir-client/resources";

const useUserPractitionerRole = () => {
  const [practitionerRoles, setPractitionerRoles] = useState<string[]>([]);
  const [finishedRequestingPractitioners, setFinishedRequestingPractitioners] = useState(false);
  
  const user = useAuth();

  const userFhirRef = useMemo(() => {
    if (user) {
      const currentUser = user.getCurrentUser();
      return currentUser?.user_fhir_uri ?? null;
    }
    return null;
  }, [user]);

  const userFhirId = useMemo(() => {
    if (userFhirRef) {
      return userFhirRef?.split('/')?.[1] ?? null;
    }
    return null;
  }, [userFhirRef]);

  const getPractitionerRoles = async () => {
    try {
      const response = await fhirClient.findAll<PractitionerRole>('PractitionerRole', {
        practitioner: userFhirId,
        active: true,
      });

      const resourceEntries =
        response?.entry?.reduce((resources: any[], { resource }: any) => {
          return [...resources, resource];
        }, []) ?? [];

      const practitionerRolesByUser = resourceEntries?.map((role: any) => (
        `${role?.resourceType}/${role?.id}`
      )) ?? [];

      setPractitionerRoles(practitionerRolesByUser);
      setFinishedRequestingPractitioners(true);
    } catch (error) {
      console.error(error);
      throw new Error('Failed to get practitioner role data');
    }
  };

  useEffect(() => {
    if (userFhirId) {
      getPractitionerRoles();
    }
  }, [userFhirId]);

  return {
    practitionerRoles,
    finishedRequestingPractitioners,
  };
}

export default useUserPractitionerRole;